import styled from "styled-components";

export const MinimumGamblingAgeIconDefaultBox = styled.div<{imageUrl: string, isShownInHeader: boolean}>`
  background-image: url(${props => props.imageUrl});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  height: 27px;
  width: ${props=> props.isShownInHeader === true ? "35px" : "27px"};
`